import { render, staticRenderFns } from "./EmsProductPage.vue?vue&type=template&id=6dd5c806"
import script from "./EmsProductPage.vue?vue&type=script&lang=js"
export * from "./EmsProductPage.vue?vue&type=script&lang=js"
import style0 from "./EmsProductPage.vue?vue&type=style&index=0&id=6dd5c806&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports